export default __webpack_public_path__ + "static/media/talentsmalllogo.34fd99b8.png";